module.exports = __webpack_public_path__ + "static/media/FotosCentro11.a42599b9.jpg";